/**
 * pdf.js 6 (ngx-extended-pdf-viewer 30) ships a «modern» build that uses very recent built-ins
 * (Map.prototype.getOrInsertComputed, Math.sumPrecise, Promise.try, …). The viewer's own probe only checks older
 * features, so browsers on an older engine (e.g. Samsung Internet) load the modern build and hang forever.
 * `true` → bind `[forceUsingLegacyES5]` so they get the polyfilled legacy build instead.
 */
export function pdfViewerNeedsLegacyBuild(globals: {
  Map?: { prototype?: object };
  Math?: object;
  Promise?: object;
} = globalThis as never): boolean {
  const mapProto = globals.Map?.prototype as Record<string, unknown> | undefined;
  const math = globals.Math as Record<string, unknown> | undefined;
  const promise = globals.Promise as Record<string, unknown> | undefined;
  return (
    typeof mapProto?.['getOrInsertComputed'] !== 'function' ||
    typeof math?.['sumPrecise'] !== 'function' ||
    typeof promise?.['try'] !== 'function'
  );
}
